import {createSelector} from 'reselect'

export const user = createSelector(
  state => state.application.user,
  user => user
);

export const userFacility = createSelector(
  user,
  state => state.application.entities.facilities,
  (user, facilities) => facilities[user.facility] || {}
);

export const reviewers = createSelector(
  state => state.application.entities.reviewers,
  reviewers => Object.keys(reviewers).map(id => reviewers[id])
);

export const MQDs = createSelector(
  state => state.application.entities.MQDs,
  MQDs => Object.keys(MQDs).map(id => MQDs[id])
);

export const roles = createSelector(
  user,
  ({roles}) => ({
    // mqd: roles.includes('ePASRR_MQD'),
    nursingFacility: roles.includes('ePASRR_NursingFacility'),
    admin: roles.includes('ePASRR_Administrator') || roles.includes('ePASRR_HSAG') || roles.includes('ePASRR_MQD'),
  })
);

export const irrRoles = createSelector(
  user,
  ({roles}) => ({
    mqd: roles.includes('ePASRR_MQD'),
    hsag: roles.includes('ePASRR_Administrator') || roles.includes('ePASRR_HSAG'),
  })
);

export const notifications = createSelector(
  state => state.application.entities.notifications,
  notifications => {
    const ns = Object.keys(notifications).map(id => ({id, ...notifications[id]}));
    return ({
      error: ns.filter(x => x.type === 'error'),
      success: ns.filter(x => x.type === 'success'),
      warning: ns.filter(x => x.type === 'warning')
    });
  }
);

export const notificationIds = createSelector(
  state => state.application.entities.notifications,
  notifications => Object.keys(notifications)
);

export const epasrrUrl = createSelector(
  state => state.application.epasrrUrl,
  x => x
);

export const fetchingData = createSelector(
  state => state.application,
  application => Object.keys(application.fetching).some(key => application.fetching[key] === true)
);

export const fetchingNavigation = createSelector(
  state => state.application,
  app => app.fetching.navigation
);

export const navigationItems = createSelector(
  state => state.application,
  app => app.navigation
);

export const breadCrumbs = createSelector(
  state => state.application,
  app => app.breadCrumbs
);



// WEBPACK FOOTER //
// ./src/application.selectors.js